import { EditSensorDataSort, SensorDataPoint } from './editSensorData.types';

import { Geometry } from '@Types/geometry.types';
import { TFunc } from '../i18n/types';
import { PaginationInfo } from './pagination.types';
import { ConfigurationStatus } from './configuration.types';

// Structure in MongoDB

export interface Sensor {
	_id: string;
	assetType?: string;
	sensorId?: string;
	assetId?: string;
	channelType: string;
	geometry?: Geometry;
	x?: number;
	y?: number;
	z?: number;
	alias?: string;
	locationDescription?: string;
}

export interface ConfiguredSensor {
	sensorId: string;
	sensorAlias: string;
	sensorType: string;
	unit: string;
	channelType: string;
	assetName: string;
	resolutions: string;
}

export interface TimeSeriesUploadElement {
	name: string;
	url: string;
}

export interface TimeSeriesUploadWithFile extends TimeSeriesUploadElement {
	file: File;
}

export type UploadFileStatusType =
	| 'ready'
	| 'scanning'
	| 'preparing'
	| 'uploading'
	| 'completed'
	| 'error'
	| 'initial';

export const uploadFileStatusTypes: Record<string, UploadFileStatusType> = {
	scanning: 'scanning',
	ready: 'ready',
	preparing: 'preparing',
	uploading: 'uploading',
	completed: 'completed',
	error: 'error',
	initial: 'initial',
};

export type ValidDateFormat =
	| 'L/d/yy H:m'
	| 'LL/dd/yyyy HH:mm:ss'
	| 'yyyy/LL/dd HH:mm:ss'
	| 'yyyy-LL-dd HH:mm:ss';

export const UPLOAD_FILE_STATUS_TEXT = (
	t: TFunc,
): Record<UploadFileStatusType, string> => ({
	ready: t('Ready for upload'),
	scanning: t('Scanning for errors'),
	preparing: t('Preparing for upload'),
	uploading: t('Uploading'),
	completed: t('Successfully uploaded'),
	error: t('Error uploading'),
	initial: '',
});

export interface SensorPointsFormikProps {
	points: SensorDataPoint[];
	sort?: EditSensorDataSort;
}

export interface VirtualSensor {
	sensorId: string;
	sensorAlias: string;
	sensorType: string;
	sensorUnit: string;
	channelType: string;
	assetName: string;
	resolutions: string;
}

/** Passed by sensor API */
export interface SensorResponse {
	sensorId: string;
	sensorAlias: string;
	sensorType: string;
	sensorUnit: string;
	channelType: string;
	assetName: string;
	resolutions: string;
}

export interface VirtualSensorCountStore {
	initialized: boolean;
	virtualCount?: number;
	isError: boolean;
}

export interface VirtualSensorsCountResponse {
	sensors: SensorResponse[];
	pagination: PaginationInfo;
}

export interface PhysicalSensorCountStore {
	initialized: boolean;
	physicalCount?: number;
	isError: boolean;
}

export interface PhysicalSensorsCountResponse {
	sensors: SensorResponse[];
	pagination: PaginationInfo;
}

export interface SensorsResponse {
	sensors: SensorResponse[];
}

export type FilterVirtualSensor = Partial<VirtualSensor>;

type HealthStatus = {
	status: ConfigurationStatus;
	latestValue?: number;
};
export type SensorsHealthStatus = {
	[key: string]: HealthStatus;
};

type Uptime = {
	latestValue: string;
	lastValueTimestamp: number;
};
export type SensorsUptime = {
	[key: string]: Uptime;
};
